import { Component } from '@angular/core';
import {ProductSummaryComponent} from "@spartacus/storefront";
import {isAsturias} from "../../utils/check-environment";
import {Product} from "@spartacus/core";

@Component({
  selector: 'cx-product-summary',
  standalone: false,
  templateUrl: './gonvarri-product-summary.component.html',
  styleUrl: './gonvarri-product-summary.component.scss'
})
export class GonvarriProductSummaryComponent extends ProductSummaryComponent {

  formatPriceMinQuantity(minQuantity: number): string {
    const formattedValue = this.formatQuantity(minQuantity);
    return formattedValue === "0,00" ? "0" : formattedValue;
  }

  getVolumePricesLenght(product: Product): number {
    return (product.volumePrices?.length) ?? 0;
  }

  formatPriceMaxQuantity(maxQuantity: number): string {
    return this.formatQuantity(maxQuantity);
  }

  private formatQuantity(quantity: number): string {
    return (quantity / 1000).toFixed(2).toString().replaceAll(".", ",");
  }

  getPriceComplement(): string {
    return !isAsturias() ? " / Tm" : " / 100m.l.";
  }

  isContract(product: any): boolean {
    return product.isContract;
  }
}
